import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import NotFound from "./pages/NotFound";
import GuestsRouter from "./modules/Guests/GuestsRouter";
import MyGiftTableRouter from "./modules/MyGiftTable/MyGiftTableRouter";
import RegistrationRouter from "./modules/Registration/RegistrationRouter";
import ThemeLoader from "./components/ThemeLoader/ThemeLoader";
import InitPage from "./modules/Registration/pages/InitPage";
import LanguageModalProvider from "./components/LanguageModalProvider/LanguageModalProvider";

const App: React.FC = () => {
  return (
    <LanguageModalProvider>
      <Router>
        <ThemeLoader />
        <Routes>
          <Route path="/*" element={<InitPage />} />
          <Route path="/guests/*" element={<GuestsRouter />} />
          <Route path="/registration/*" element={<RegistrationRouter />} />
          <Route path="/my-table/*" element={<MyGiftTableRouter />} />
          <Route path="/not-found" element={<NotFound />} />
        </Routes>
      </Router>
    </LanguageModalProvider>
  );
};

export default App;
